import { ClipboardListIcon } from 'lucide-react';
import { useSearchParams } from 'react-router';

import AssignmentCard from '@/components/features/assignments/AssignmentCard';
import AssignmentCardSkeleton from '@/components/features/assignments/AssignmentCardSkeleton';
import AssignmentsHeader from '@/components/features/assignments/header/AssignmentsHeader';
import { EmptyState, EmptyStateCircles, EmptyStateContent, EmptyStateDescription, EmptyStateTitle } from '@/components/ui/empty-state';
import { FeaturedIcon } from '@/components/ui/featured-icon';
import { InfiniteScroll } from '@/components/ui/infinite-scroll/InfiniteScroll';
import { useAssignedAssignmentsData } from '@/hooks/assignment';

export default function AssignmentsPage() {
  const [searchParams] = useSearchParams();
  const groupIdParam = searchParams.get('groupId');
  const groupId = groupIdParam ? Number(groupIdParam) : undefined;
  const { state, actions } = useAssignedAssignmentsData({ groupId });

  return (
    <div className="base-direction-col">
      <AssignmentsHeader onSearchChange={actions.setSearchValue} filterValue={state.filterValue} onFilterChange={actions.setFilterValue} />
      <div className={'relative grid w-full grid-cols-[repeat(auto-fill,minmax(18rem,1fr))] grid-rows-[auto] gap-3 md:gap-4'}>
        {state.isEmpty && !state.isPending && (
          <EmptyState className="col-span-full">
            <EmptyStateCircles className={'z-0'} />
            <FeaturedIcon size={'lg'} className={'z-10'}>
              <ClipboardListIcon />
            </FeaturedIcon>
            <EmptyStateContent>
              <EmptyStateTitle>Brak zadań</EmptyStateTitle>
              <EmptyStateDescription>Brak zadań dostępnych w tej chwili.</EmptyStateDescription>
            </EmptyStateContent>
          </EmptyState>
        )}

        {state.noResults && (
          <EmptyState className="col-span-full">
            <EmptyStateCircles className={'z-0'} />
            <FeaturedIcon size={'lg'} className={'z-10'}>
              <ClipboardListIcon />
            </FeaturedIcon>
            <EmptyStateContent>
              <EmptyStateTitle>Brak wyników</EmptyStateTitle>
              <EmptyStateDescription>Brak wyników dla podanych kryteriów, spróbuj zmienić filtry lub wyszukiwanie.</EmptyStateDescription>
            </EmptyStateContent>
          </EmptyState>
        )}

        {state.data.map((item) => (
          <AssignmentCard key={item.id} data={item} />
        ))}

        {state.isLoading && (
          <>
            <AssignmentCardSkeleton />
            <AssignmentCardSkeleton />
            <AssignmentCardSkeleton />
            <AssignmentCardSkeleton />
          </>
        )}

        <InfiniteScroll hasNextPage={state.hasNextPage} isLoading={state.isLoading} isFetching={state.isFetching} next={actions.next} threshold={0.65}>
          {state.hasNextPage && !state.isError && <AssignmentCardSkeleton />}
        </InfiniteScroll>
      </div>
    </div>
  );
}
